import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  withCredentials: true
});

export const getMe = () => api.get('/auth/me');
export const logout = () => window.location.href = '/auth/logout';
export const scanDoc = (formData) => api.post('/api/ocr/scan', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const dispatchDoc = (formData) => api.post('/api/dispatch', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const getDocs = (params) => api.get('/api/docs', { params });

export default api;
